import React from 'react'

export const BigCupIcon = () => (
  <svg version="1.1" id="Layer_1"
    xmlns="http://www.w3.org/2000/svg" width="40px" height="40px"
    viewBox="0 0 62 64" enable-background="new 0 0 62 64">
    <g id="Page-1">
      <g id="Cup" transform="translate(1.000000, 1.000000)">
        <path id="Shape_1_" fill="none" stroke="currentColor" stroke-width="2" d="M11.5,4H0.1c0,0-2.4,30,24.5,30
          "/>
        <path id="Shape_2_" fill="none" stroke="currentColor" stroke-width="2" d="M49.1,4h10.8
          c0,0,2.5,30-23.6,30"/>
        <path id="Shape_3_" fill="none" stroke="currentColor" stroke-width="2" d="M19.2,55v-2c0-1.1,0.9-2,2.1-2
          l4.1-1c2-5,2.4-7.9,2.1-12h-1c-1.2,0-2.1-0.9-2.1-2.1v-3.1C13.3,28,11,10.4,11,0h39c0,10.5-2.3,28.1-13.4,32.8v3.1
          c0,1.2-1,2.1-2.1,2.1h-0.8c-0.3,4.1,0,7.1,2,12l5.1,1c1.1,0,2.1,0.9,2.1,2v2"/>
        <path id="Shape_4_" fill="none" stroke="currentColor" stroke-width="2" d="M15.8,4.2
          c0,0,0.5,17.9,6.9,22.8"/>
        <path id="Shape" fill="none" stroke="currentColor" stroke-width="2" d="M39,55h6.1c1.1,0,3.9,5,3.9,5
          c0,1.1-0.9,2-1.9,2H15c-1.1,0-1.9-0.9-1.9-2c0,0,2.8-5,3.9-5h6.1"/>
      </g>
    </g>
  </svg>
)
